export const assertEventsOrderResponseSuccess = (
	status: number,
	message: string,
	data?: unknown,
	successStatuses: number[] = [200, 201],
) => {
	if (successStatuses.includes(status)) return;

	const error = new Error(message);
	(error as any).data = data;
	throw error;
};
